import { ZonedDateTimeFactory } from '@csp/csp-common-date-util';
import { OrgId, Site, SiteECApprovalStatus } from '@csp/csp-common-model';
import { createOrgV1Mock, OrgType } from '@csp/dmdp-api-org-dto';
import { createMockCreator } from '@csp/test-common-utils';
import { SiteMapper } from '../../mapper/SiteMapper';

export const createSiteMock = createMockCreator<Site>({
  ...SiteMapper.from(
    createOrgV1Mock({
      type: OrgType.PRACTICE,
      country: undefined,
      branchParentIds: ['country_1'],
      practice: {
        practiceType: '',
        addresses: [],
        locations: [],
        practiceCode: '1234',
      },
    }),
  ),
  displayNameLeadingSiteNumber: '',
  ecApprovalStatus: {
    confirmedAt: ZonedDateTimeFactory.now(),
    confirmedBy: 'abc123',
    status: SiteECApprovalStatus.NOT_APPROVED,
  },
});

const fromPartial = (partialMock?: Partial<Site>, parentIds?: OrgId[]): Site => ({
  ...SiteMapper.from(
    createOrgV1Mock({
      type: OrgType.PRACTICE,
      country: undefined,
      branchParentIds: parentIds ?? [],
      practice: {
        practiceType: '',
        addresses: [],
        locations: [],
        practiceCode: '1234',
      },
    }),
  ),
  displayNameLeadingSiteNumber: '',
  ecApprovalStatus: {
    confirmedAt: ZonedDateTimeFactory.now(),
    confirmedBy: 'abc123',
    status: SiteECApprovalStatus.NOT_APPROVED,
  },
  ...partialMock,
});

export const SiteMock = {
  fromPartial,
};
